import {Radio as NewBaseRadio} from '@esgi/ui-kit/control';
import {Radio as NewControlRadio} from '@esgi/ui-kit/form-control';

export const BaseRadio = NewBaseRadio;
export const Radio = NewControlRadio;
